import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { Project, Pipeline, ProjectTemplate } from 'app/modules/projects/projects.types';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { ProjectsService } from '../../projects.service';

export interface ProjectEditPipelineData {
  project: Project;
  pipelines: Pipeline[];
  data: any;
}

@Component({
  selector: 'project-change-layouts',
  templateUrl: './project-change-layouts.component.html',
  styleUrls: ['./project-change-layouts.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProjectChangeLayoutsComponent implements OnInit {
  addProjectForm: UntypedFormGroup;
  project: Project;
  projects: Project[];
  pipelines: Pipeline[];
  projectTemplates: ProjectTemplate<any>[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<ProjectChangeLayoutsComponent>,
    private _formBuilder: UntypedFormBuilder,
    private _projectsService: ProjectsService,
  ) {}

  ngOnInit() {
    this.addProjectForm = this._formBuilder.group({
      template_id: [''],
    });

    if (this.data.project) {
      this.project = this.data.project;
      if (this.data.project.template) {
        this.addProjectForm.get('template_id').setValue(this.data.project.template?.id);
      }
    } else if (this.data.projects) {
      this.projects = this.data.projects;
    }
    this.pipelines = this.data.pipelines;
    if (this.project) {
      this._projectsService.getProjectById(this.project.id).subscribe((p) => {
        this.addProjectForm.get('template_id').setValue(p.template?.id);
      });
    }
    this.projectTemplates = this.data.data.options.project_templates
      .filter((option) => !option.hidden && option.related_to_type == 'Project')
      .sort((a, b) => a.name.localeCompare(b.name));
  }

  discard(): void {
    this.matDialogRef.close({ moved: false });
  }

  save() {
    this.addProjectForm.disable();

    const projectForm = this.addProjectForm.value;

    if (this.project) {
      const payload = {
        id: this.project.id,
        template_id: projectForm.template_id,
      };

      this._projectsService.saveProject(payload as Project).subscribe((project) => {
        this.matDialogRef.close({ moved: true });
      });
    } else if (this.projects) {
      const projectsToUpdate = this.projects.map((project) => ({
        id: project.id,
        template_id: projectForm.template_id,
      }));

      this._projectsService.saveProjects(projectsToUpdate as Project[]).subscribe();
      this.matDialogRef.close({ updated: true });
    }
  }
}
